import { createSlice } from '@reduxjs/toolkit';

const notificationSlice = createSlice({
  name: 'notification',
  initialState: {
    open: false,
    message: '',
    severity: 'info', // 'success', 'error', 'warning', 'info'
    title: null,
    duration: 2000,
  },
  reducers: {
    showNotification: (state, action) => {
      state.open = true;
      state.message = action.payload.message;
      state.severity = action.payload.severity || 'info';
      state.title = action.payload.title || null;
      // Errors/warnings stay on screen long enough to actually read them
      // (validation messages can be long). Callers can still override `duration`.
      const defaultDuration =
        state.severity === 'error' ? 10000 : state.severity === 'warning' ? 7000 : 2000;
      state.duration = action.payload.duration || defaultDuration;
    },
    clearNotification: (state) => {
      state.open = false;
      state.message = '';
      state.title = null;
    },
  },
});

export const { showNotification, clearNotification } = notificationSlice.actions;
export default notificationSlice.reducer;

